<template>
  <div class="passport-container">
    <div class="logo-container">
      <div class='logo'><a href="/"><img src="../../assets/images/logo.png" height="32px" width="125px"/></a></div>
    </div>
    <div class="passport" v-if="step == 1">
      <!-- <h1>登录</h1> -->
      <el-tabs  class="tt-custom-tab" v-model="loginType" @tab-click="tabChange()">
        <el-tab-pane v-for="(tab,index) in tabs" :key="index" :label="tab.label" :name="tab.name">
        <div class="error-tip-container">
          <p class="error-tip mini red-txt lighter-red-bg text-center" v-if="errorText">{{errorText}}</p>
        </div>
        <div class="text-center" style="height: 280px;padding-top: 90px;" v-show="loading">
          <Loading type="1"></Loading>
        </div>
        <form autocomplete="off" v-if="!loading">
          <div v-if="loginType == 'password'">
            <YueDanIpt class="username" model="username" :focus="true" :object="login" placeholder="邮箱/手机/用户名"></YueDanIpt>
            <YueDanIpt model="password" type="password" :object="login" placeholder="密码">
              <a class="normal-content get-password" href="/forget_pwd">忘记密码</a>
              <a class="dialog-content get-password" @click="showForgetPwdDialog()">忘记密码</a>
            </YueDanIpt>
            <div class="btn-container">
              <el-button type="primary block" @click="submit()" :loading="loading">登&nbsp;录</el-button>
            </div>
          </div>
          <div v-if="loginType == 'mobile'">
            <div style="margin-bottom:10px;margin-top:10px;">
              <div style="width:28%;display:inline-block;vertical-align: middle;" class="areaCode">
                <el-select v-model="form.areaCode" placeholder="区号" @change="selectCode">
                  <el-option v-for="(item,index) in reorder" :key="index" :label="'+'+item.key" :value="item.key">
                    <span >
                        <div >{{item.value}}</div>
                    </span>
                  </el-option>
                </el-select>
              </div>
              <div style="width:70%;display:inline-block;vertical-align: middle;">
                <YueDanIpt model="mobile" :object="form" placeholder="手机号" v-on:areaSelect="areaSelect"></YueDanIpt>
              </div>
            </div>
            <YueDanIpt model="verify_code" type="password" :object="form" placeholder="验证码">
              <a v-if="!seconds" class="get-password" style="cursor:pointer;" @click="getLoginCode()">获取验证码</a>
              <a v-if="seconds" class="get-password" >{{seconds}} s</a>
            </YueDanIpt>
            <div class="btn-container">
              <el-button type="primary block" @click="loginByMobile()" :loading="loading">登&nbsp;录</el-button>
            </div>
          </div>
          <div class="footer-container">
            <a class="normal-content" href="/register">创建一个账户</a>
            <a class="dialog-content" @click="showRegisterDialog()">创建一个账户</a>
          </div>
        </form>
        <div v-if="!loading">
          <a class="line">或</a>
        </div>
        <div style="width:100%;" v-if="!loading">
          <el-button type="primary block" style="background-color:#67c23a !important;border-color: #67c23a !important;" @click="getLoginUrl()" :loading="loading">微&nbsp;信&nbsp;登&nbsp;录</el-button>
        </div>
      </el-tab-pane>
      </el-tabs>
    </div>
    <div class="passport" v-if="step == 2">
      <div class="text-center" style="height: 280px;padding-top: 90px;" v-show="loading">
        <Loading type="1"></Loading>
      </div>
      <div v-if="!loading">
        <h2 class="text-center" style="position:relative"><i v-if="step == 2" class="el-icon-arrow-left back" @click="goback()"></i>微信登录</h2>
        <div class="img">
            <img width="220" :src="url" />
        </div>
        <div class="text-center">
          <div class="button">
              请使用请微信扫描二维码登录
  “JoyOrders”
          </div>
        </div>
      </div>
    </div>
    <div class="passport" v-if="step == 3">
      <div class="text-center" style="height: 280px;padding-top: 90px;" v-show="loading">
        <Loading type="1"></Loading>
      </div>
      <div v-if="!loading">
        <h2 class="text-center" style="position:relative"><i v-if="step != 1" class="el-icon-arrow-left back" @click="goback()"></i>微信绑定</h2>
        <div class="head">
          <img :src="headimgurl" alt="">
          Hi,欢迎来JoyOrders,完成绑定后可以微信账号一键登录哦~
        </div>
        <div class="error-tip-container">
          <p class="error-tip mini red-txt lighter-red-bg text-center" v-if="errorText">{{errorText}}</p>
        </div>
        <form autocomplete="off" v-if="!loading">
          <YueDanIpt class="username" model="username" :focus="true" :object="login" placeholder="邮箱/手机/用户名"></YueDanIpt>
          <YueDanIpt model="password" type="password" :object="login" placeholder="密码">
            <a class="normal-content get-password" href="/forget_pwd">忘记密码</a>
            <a class="dialog-content get-password" @click="showForgetPwdDialog()">忘记密码</a>
          </YueDanIpt>
          <div class="btn-container">
            <el-button type="primary block" @click="bind()" :loading="loading">绑&nbsp;定</el-button>
          </div>
          <div class="footer-container">
            <a class="normal-content" href="/register">没有JoyOrders账号，立即注册</a>
            <a class="dialog-content" @click="showRegisterDialog()">没有JoyOrders账号，立即注册</a>
          </div>
        </form>
      </div>
    </div>
    <div class="passport" v-if="step == 4">
      <h2 class="text-center" style="position:relative;margin-bottom:20px;">绑定手机号</h2>
      <div class="error-tip-container">
        <p class="error-tip mini red-txt lighter-red-bg text-center" v-if="errorText">{{errorText}}</p>
      </div>
      <div class="text-center" style="height: 280px;padding-top: 90px;" v-show="loading">
        <Loading type="1"></Loading>
      </div>
      <form autocomplete="off" v-if="!loading">
        <div>
          <div style="width:28%;display:inline-block;vertical-align: middle;" class="areaCode">
            <el-select v-model="form.areaCode" placeholder="区号" @change="selectCode">
              <el-option v-for="(item,index) in reorder" :key="index" :label="'+'+item.key" :value="item.key">
                <span >
                    <div >{{item.value}}</div>
                </span>
              </el-option>
            </el-select>
          </div>
          <div style="width:70%;display:inline-block;vertical-align: middle;">
            <YueDanIpt class="username" model="mobile" :object="form" placeholder="手机号" v-on:areaSelect="areaSelect"></YueDanIpt>
          </div>
        </div>
        <YueDanIpt model="verify_code" type="password" :object="form" placeholder="验证码">
          <a v-if="!seconds" class="get-password" style="cursor:pointer;" @click="getCode()">获取验证码</a>
          <a v-if="seconds" class="get-password" >{{seconds}} s</a>
        </YueDanIpt>
        <div class="btn-container">
          <el-button type="primary block" @click="bindMobile()" :loading="loading">绑&nbsp;定</el-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import api from '../../services/api.js'
import YueDanIpt from '../../components/YueDanIpt'
import Loading from '../../components/Loading'
import { API_HOST, FILE_HOST, areaCode, phoneReg} from '../../services/constant.js'


let $ = require('jQuery')

export default {
  name: 'Login',
  props: ['isDialog'],
  components: {
    YueDanIpt: YueDanIpt,
    Loading: Loading,
  },
  data () {
    return {
      loginType:'mobile',
      tabs:[
        {label:'快捷登录',name:'mobile'},
        {label:'密码登录',name:'password'}
      ],
      token:null,
      account_id:null,
      areaCode:areaCode,
      phoneReg:phoneReg,
      seconds:null,
      login: {
        username: '',
        password: ''
      },
      form:{
        mobile: '',
        verify_code:'',
        areaCode:'86'
      },
      mobileReg:/^(\+?0?86\-?)?1[345789]\d{9}$/,
      loading: false,
      errorText: '',
      ifr: null,
      fromPath: null,
      step: 1,
      url: null,
      checkLoginStatusInterval: null,
      scene_id: null,
      open_id:null,
      headimgurl:null,
    }
  },
  computed:{
    reorder: function() {
      return this.areaCode.sort(function(x,y){
        return x['value'].localeCompare(y['value'])
      })
    }
  },
  created() {
    console.log(document.referrer)
    this.initBbs()
    this.$store.commit('updateNim', {
      showChat: false
    })
    this.getOpenIdFromWx()
  },
  mounted(){
     this.$nextTick(()=>{
       console.log(this.fromPath)
     })
  },
  methods: {
    tabChange(){
      this.errorText = ''
      this.form = {
        mobile: '',
        verify_code:'',
        areaCode:'86'
      }
      this.mobileReg = /^(\+?0?86\-?)?1[345789]\d{9}$/
    },
    selectCode(item){
      console.log(item)
      _.each(this.areaCode,list =>{
        if(list.key == item){
          if(list.reg){
            this.mobileReg = this.phoneReg[list.reg]
          }else{
            this.mobileReg = /^[0-9]{0,11}$/
          }
          return false
        }
      })
      console.log(this.mobileReg)
    },
    getLoginCode(){
      if(!this.form.mobile){
        this.errorText = '手机号是必填项'
        return
      }else if(!(this.mobileReg.test(this.form.mobile))){
        this.errorText = '请输入有效的手机号码'
        return
      }else{
        this.errorText = ''
      }
      api.post(this, {
        path: 'passport_v2.php',
        api: 'login_send_sms',
        data: {mobile:this.form.mobile,mobile_country_code:this.form.areaCode}
      }).then((res) => {
        if(res.body.result == 'send_after_two_minutes'){
          this.errorText = '操作频繁，请稍后再试'
          return
        }
        if(res.body.result == 'no_such_user'){
          this.errorText = '该手机尚未注册,请前去注册'
          return
        }
        this.seconds = 60
        let timer = setInterval(() => {
          this.seconds --
          if (this.seconds == 0) {
            clearInterval(timer)
          }
        }, 1000)
      }, (err) => {
        this.loading = false
      })
    },
    loginByMobile(){
      this.errorText = ''
      if(!this.form.mobile){
        this.errorText = '手机号是必填项'
        return
      }
      if(!(this.mobileReg.test(this.form.mobile))){
        this.errorText = '请输入有效的手机号码'
        return
      }
      if(!this.form.verify_code){
        this.errorText = '验证码是必填项'
        return
      }
      this.loading = true
      api.post(this, {
        path: 'passport_v2.php',
        api: 'login_by_sms',
        data: {
          mobile:this.form.mobile,
          verify_code:this.form.verify_code,
          mobile_country_code:this.form.areaCode
        }
      }).then((res) => {
        let data = res.data
        if(data.result == 'wrong_verify_code'){
          setTimeout(() => {
            this.errorText = '手机验证码不正确'
            this.loading = false
            this.form.verify_code = ''
          }, 2000);
          return
        }else if(data.result == 'verify_code_expired'){
          setTimeout(() => {
            this.errorText = '手机验证码已过期,请重新获取'
            this.loading = false
            this.form.verify_code = ''
          }, 2000);
          return
        }else if(data.result == 'no_such_user'){
          setTimeout(() => {
            this.errorText = '该手机尚未注册,请前去注册'
            this.loading = false
            this.form.verify_code = ''
          }, 2000);
          return
        }else{
          // this.$localStorage.set('username', this.login.username)
          this.$localStorage.set('token', data.result)
          this.$localStorage.set('login_type', data.description)
          this.loginBbs()
          setTimeout(() => {
            this.loading = false
            if (this.isDialog) {
              this.$emit('success')
              location.reload()
            } else {
              if (document.referrer.indexOf('bbs.joyorders.com') > -1 ) {
                window.location.href = document.referrer;
              } else {
                // if(this.$route.query.href){
                // this.$router.push({ path: this.$route.query.href})

                // }else{
                //   this.$router.push({ path: '/' })
                // }
                if(this.fromPath){
                  if(this.fromPath == '/register' || this.fromPath == '/forget_pwd'){
                    this.$router.push({ path: '/'})
                  }else{
                    // this.$router.push({ path: this.fromPath})
                    if(document.referrer.indexOf('login') > -1 || document.referrer == '' || document.referrer.indexOf('forget_pwd') > -1 || document.referrer.indexOf('reset_password') > -1 || document.referrer.indexOf('register') > -1){
                      this.$router.push({ path: '/'})
                    }else{
                      window.location.href = document.referrer;
                    }

                  }
                }
              }
            }
          }, 2000)
          return false
        }
      }, (err) => {
        this.loading = false
      })
    },
    areaSelect(data){
      this.form.areaCode = data
    },
    getCode(){
      if(!this.form.mobile){
        this.errorText = '手机号是必填项'
        return
      }else if(!(this.mobileReg.test(this.form.mobile))){
        this.errorText = '请输入有效的手机号码'
        return
      }else{
        this.errorText = ''
      }
      api.post(this, {
        path: 'passport_v2.php',
        api: 'bind_mobile_send_sms',
        data: {mobile:this.form.mobile,mobile_country_code:this.form.areaCode,username:this.login.username}
      }).then((res) => {
        if(res.body.result == 'send_after_two_minutes'){
          this.errorText = '操作频繁，请稍后再试'
          return
        }
        if(res.body.result == 'mobile_exist'){
          this.errorText = '该手机号码已绑定其他用户,请更换其他手机号码'
          return
        }
        this.seconds = 60
        let timer = setInterval(() => {
          this.seconds --
          if (this.seconds == 0) {
            clearInterval(timer)
          }
        }, 1000)
      }, (err) => {
        this.loading = false
      })
    },
    bindMobile(){
      this.errorText = ''
      if(!this.form.mobile){
        this.errorText = '手机号是必填项'
        return
      }
      if(!this.form.verify_code){
        this.errorText = '验证码是必填项'
        return
      }
      this.loading = true
      api.post(this, {
        path: 'passport_v2.php',
        api: 'bind_mobile_submit',
        data: {
          mobile:this.form.mobile,
          verify_code:this.form.verify_code,
          mobile_country_code:this.form.areaCode,
          account_id:this.account_id
        }
      }).then((res) => {
        let data = res.data
        if(data.result == 'wrong_verify_code'){
          setTimeout(() => {
            this.errorText = '手机验证码不正确'
            this.loading = false
            this.form.verify_code = ''
          }, 2000);
          return
        }else if(data.result == 'verify_code_expired'){
          setTimeout(() => {
            this.errorText = '手机验证码已过期,请重新获取'
            this.loading = false
            this.form.verify_code = ''
          }, 2000);
          return
        }else if(data.result == 'mobile_exist'){
          setTimeout(() => {
            this.errorText = '该手机号码已绑定其他用户,请更换其他手机号码'
            this.loading = false
            this.form.verify_code = ''
          }, 2000);
          return
        }else{
          this.$localStorage.set('username', this.login.username)
          this.$localStorage.set('token', this.token)
          this.$localStorage.set('login_type', data.description)
          this.loginBbs()
          setTimeout(() => {
            this.loading = false
            if (this.isDialog) {
              this.$emit('success')
              location.reload()
            } else {
              if (document.referrer.indexOf('bbs.joyorders.com') > -1 ) {
                window.location.href = document.referrer;
              } else {
                // if(this.$route.query.href){
                // this.$router.push({ path: this.$route.query.href})

                // }else{
                //   this.$router.push({ path: '/' })
                // }
                if(this.fromPath){
                  if(this.fromPath == '/register' || this.fromPath == '/forget_pwd'){
                    this.$router.push({ path: '/'})
                  }else{
                    // this.$router.push({ path: this.fromPath})
                    if(document.referrer.indexOf('login') > -1 || document.referrer == '' || document.referrer.indexOf('forget_pwd') > -1 || document.referrer.indexOf('reset_password') > -1 || document.referrer.indexOf('register') > -1){
                      this.$router.push({ path: '/'})
                    }else{
                      window.location.href = document.referrer;
                    }

                  }
                }
              }
            }
          }, 2000)
          return false
        }
      }, (err) => {
        this.loading = false
      })
    },
    submit: function () {
      let res, err = this.validation()
      if (err) {
        this.errorText = err
        return false
      }
      this.errorText = ''
      this.loading = true
      api.post(this, {
        path: 'passport_v2.php',
        api: 'login',
        data: this.login
      }).then((res) => {
        let data = res.data
        if (data.status === 'ok') {
          this.token = data.result.token
          this.account_id = data.result.account_id
          if(!data.result.is_bind_mobile){
            this.step = 4
            this.loading = false
            return
          }
          this.$localStorage.set('username', this.login.username)
          this.$localStorage.set('token', data.result.token)
          this.$localStorage.set('login_type', data.description)
          this.$localStorage.set('lunxun', '1')
          this.loginBbs()
          setTimeout(() => {
            this.loading = false
            if (this.isDialog) {
              this.$emit('success')
              location.reload()
            } else {
              if (document.referrer.indexOf('bbs.joyorders.com') > -1 ) {
                window.location.href = document.referrer;
              } else {
                // if(this.$route.query.href){
                // this.$router.push({ path: this.$route.query.href})

                // }else{
                //   this.$router.push({ path: '/' })
                // }
                if(this.fromPath){
                  if(this.fromPath == '/register' || this.fromPath == '/forget_pwd'){
                    this.$router.push({ path: '/'})
                  }else{
                    // this.$router.push({ path: this.fromPath})
                    if(document.referrer.indexOf('login') > -1 || document.referrer == '' || document.referrer.indexOf('forget_pwd') > -1 || document.referrer.indexOf('reset_password') > -1 || document.referrer.indexOf('register') > -1){
                      this.$router.push({ path: '/'})
                    }else{
                      if((data.result.has_single == 1 || data.result.has_shipping_manager == 1) && `http://${window.location.host}/` === document.referrer){
                        sessionStorage.setItem('isSingle', data.result.has_single)
                        sessionStorage.setItem('has_shipping_manager',data.result.has_shipping_manager)
                        this.$router.push({ path: '/buyer/task/list?page=1'})
                      }
                      else
                        window.location.href = document.referrer;
                    }

                  }
                }
              }
            }
          }, 2000)
          return false
        }
        this.errorText = '信息有误，无法登录'
        this.loading = false
        // switch (data.result) {
        //   case 'wrong_password':
        //     this.errorText = '密码错误'
        //     break
        //   case 'need_username':
        //     this.errorText = '请输入用户名'
        //     break
        //   case 'need_password':
        //     this.errorText = '请输入密码'
        //     break
        // }
      }, (err) => {
        this.loading = false
      })
    },
    validation: function () {
      if (!$.trim(this.login.username)) {
        return null, '用户名是必填项'
      }
      if (!$.trim(this.login.password)) {
        return null, '密码是必填项'
      }
    },
    showRegisterDialog () {
      this.$store.commit('showGlobalDialog', 'registerVisible')
    },
    showForgetPwdDialog () {
      this.$store.commit('showGlobalDialog', 'forgetPwdVisible')
    },
    initBbs() {
      try {
        $('#bbsIframe').remove()
        document.domain = 'joyorders.com'
        var ifr = document.createElement('iframe')
        ifr.id = 'bbsIframe'
        ifr.src = 'https://bbs.joyorders.com/forum.php?mod=post&action=newthread&fid=2&topicsubmit=yes&infloat=yes&handlekey=fastnewpost&joyordersBbsAutoLogin=true'
        ifr.style.display = 'none'
        document.body.appendChild(ifr)
        this.ifr = ifr
        ifr.onload = () => {
        }
      } catch(e) {

      }
    },
    getOpenIdFromWx () {
      if(this.$route.query.open_id){
        this.open_id = this.$route.query.open_id
        this.$localStorage.set('openid', this.$route.query.open_id)
        let random_string = this.$route.query.random_string
        let url = API_HOST +'/wechat/api.php?api=get_user_info_by_random'
        this.$http.post(url,{random_string:random_string}).then(async data =>{
          if(data.body.status =='ok'){
            if(data.body.result.account_id > 0) {
                let res = await api.post(this, {
                  path: 'passport.php',
                  api: 'login_by_random',
                  data: {
                    random_string:random_string
                  },
                  loading: 'loading'
                })
                if(res.body.status == 'ok'){
                  this.$localStorage.set('token', res.body.result)
                  this.$router.push({ path: '/',query:this.$route.query})
                }
            }else{
              this.step = 3
            }
          }
        })
      }
    },
    loginBbs() {
      try {
        var ifr = this.ifr
        var doc = ifr.contentDocument || ifr.contentWindow.document
        $(doc.querySelector('.ls_username')).val(this.login.username)
        $(doc.querySelector('.ls_password')).val(this.login.password)
        $(doc.getElementById('loginsubmit')).submit()
      } catch(e) {

      }
    },
    getLoginUrl () {
      this.step = 2
      let url = API_HOST +'/wechat/api.php?api=get_login_qr_url'
      this.$http.get(url).then(data =>{
        this.url = data.body.result.url
        this.scene_id = data.body.result.scene_id
      })
      this.getLoginStatus()
      this.checkLoginStatusInterval = setInterval(() => {
      this.getLoginStatus()
      }, 2000)
    },
    getLoginStatus () {
      let url = API_HOST +'/wechat/api.php?api=is_scene_id_valid'
      this.$http.post(url,{scene_id:this.scene_id}).then(data =>{
          if(data.body.result.open_id) {
            this.$localStorage.set('token', data.body.result.token)
            this.$localStorage.set('openid', data.body.result.open_id)
            clearInterval(this.checkLoginStatusInterval)
            this.open_id = data.body.result.open_id
            this.getBindStatus()
          }
          if(!data.body.result.open_id && data.body.result.used == '1' ){
            this.step = 3
            this.open_id = data.body.result.tmp_open_id
            this.$localStorage.set('openid', data.body.result.tmp_open_id)
            clearInterval(this.checkLoginStatusInterval)
            this.getWeChatInfo()
          }
      })
    },
    getWeChatInfo () {
      let url = API_HOST +'/wechat/api.php?api=get_user_info&open_id=' + this.open_id
      this.$http.get(url).then(data =>{
          this.headimgurl = data.body.result.headimgurl
      })

    },
    async getINfo() {
      let { body } = await api.getUserInfo(this)
      let result = body.result
      this.$localStorage.set('username', result.username)

    },
    getBindStatus () {
      let url = API_HOST +'/wechat/api.php?api=get_bind_status'
      this.$http.get(url).then(data =>{
          if(data.body.result === 'bind') {
            this.loading = true
            this.getINfo()
            setTimeout(() => {
            this.loading = false
            if (this.isDialog) {
              console.log(window.location.hash)
              this.$emit('success')
              location.reload()
            } else {
              if (document.referrer.indexOf('bbs.joyorders.com') > -1 ) {
                window.location.href = document.referrer;
              } else {
                // if(this.$route.query.href){
                // this.$router.push({ path: this.$route.query.href})

                // }else{
                //   this.$router.push({ path: '/' })
                // }
                if(this.fromPath){
                  if(this.fromPath == '/register' || this.fromPath == '/forget_pwd'){
                    this.$router.push({ path: '/'})
                  }else{
                    this.$router.push({ path: this.fromPath})
                  }
                }
              }
            }
          }, 2000)

          }else{
            this.getWeChatInfo()
            this.step = 3
          }
      })
    },
    goback () {
      this.errorText = ''
      if(this.step != 4){
        this.login.username = ''
        this.login.password = ''
      }
      this.step = 1
      clearInterval(this.checkLoginStatusInterval)
    },
    bind () {
      let res, err = this.validation()
      if (err) {
        this.errorText = err
        return false
      }
      this.errorText = ''
      let url = 'https://wechat.joyorders.com/api.php?api=bind_user'
      this.$http.post(url,{
        open_id: this.open_id,
        username: this.login.username,
        password: this.login.password,
      }).then(data =>{
          if(data.body.result === 'success' || data.body.result === 'already_bind') {
            this.$localStorage.set('username', this.login.username)
            this.loading=true
            api.post(this, {
              path: 'passport.php',
              api: 'login',
              data: this.login
            }).then((res) => {
              let data = res.data
              if (data.status === 'ok') {
                this.$localStorage.set('login_type', data.description)
                this.$localStorage.set('token', data.result)
                this.loginBbs()
                setTimeout(() => {
                  this.loading = false
                  if (this.isDialog) {
                    this.$emit('success')
                    location.reload()
                  } else {
                    if (document.referrer.indexOf('bbs.joyorders.com') > -1 ) {
                      window.location.href = document.referrer;
                    } else {
                      if(this.fromPath){
                        if(this.fromPath == '/register' || this.fromPath == '/forget_pwd'){
                          this.$router.push({ path: '/'})
                        }else{
                          this.$router.push({ path: this.fromPath})
                        }
                      }
                    }
                  }
                }, 2000)
                return false
              }
              this.errorText = '信息有误，无法登录'
              this.loading = false
            }, (err) => {
              this.loading = false
            })

          }
      })
    },
    clear () {

    }
  },
  beforeDestroy: function() {
      clearInterval(this.checkLoginStatusInterval)
  },
  beforeRouteEnter (to, from, next){
    next(vm => {
       vm.fromPath = from.fullPath
     })
   },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.line {
    display: inline-block;
    line-height: 1;
    padding: 0 20px 0;
    margin: 20px 0;
    line-height: 1px;
    border-left: 111px solid #ddd;
    border-right: 116px solid #ddd;
    text-align: center;
    color: #888;
}
.img {
    text-align: center;
}
.button{
    width: 220px;
    background-color: #333 !important;
    border-color: #333 !important;
    color: #ffffff !important;
    display: inline-block;
    line-height: 1;
    border: 1px solid #dcdfe6;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 12px;
    border-radius: 20px;
    margin-bottom: 15px;
    span {
        display: inline-block;
        text-align: center;
        font-size: 12px;
        white-space: pre-line	;
    }
}
.back {
    position: absolute;
    left: 0;
    top: -10px;
    color: #C0C4CC;
    font-size: 26px;
    line-height: 30px;
    cursor: pointer;
}
.head {
  height: 50px;
  background-color: #eee;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: 5px;
  line-height: 1.3;

  img {
    height: 40px;
    margin-left: 10px;
    margin-right: 5px;
    float: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/passport/Login.vue